module.exports = __webpack_public_path__ + "static/media/Colette Single 2-Drawer Bed Base 120x200_White.c8c44a53.png";